export default __webpack_public_path__ + "static/media/KamilaCamillo_05.beb309db.jpg";